/*
 * @Descripttion: 直播回看
 * @Author: gouyang
 * @Date: 2021-01-21 14:54:13
 * @LastEditors: gouyang
 * @LastEditTime: 2021-03-26 17:23:53
 */
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import { RecordPlayingTime, Env, InitUserParams } from 'record-playing-time';
import livingGif from '../../../../assets/living.gif';
import { PlaybackInfo, N, ListsInfo, SelectedInfo } from '../../interface';
import { getSearchParams, getUsername, getUserId, getToken, getLeagueId } from '../../../../util';
import AxiosWrap from '../../../../lib/request';
// import apiConfig from '../../../../config/api';
import './index.less';
import { VideoMarkerPlayer } from 'video-marker-player';
import { PlayTime } from '../../../../util/playTime';

function getEnv(): Env {
  const env = (window as any).__UNION_CENTER_ENV__;
  switch (env) {
    case 'DEV':
      return 'dev';
    case 'TEST':
      return 'test';
    case 'STAGE':
      return 'pro';
    case 'PROD':
      return 'pro';
    default:
      return 'dev';
  }
}

const recordPlayingTime: RecordPlayingTime = new RecordPlayingTime(getEnv());
interface P {
  playbackInfo: PlaybackInfo;
}

function LivePlayBack(props: P) {
  const { playbackInfo } = props;
  const PlayTimeFn = PlayTime();
  let isTurnTo = useRef(false);
  let xgPlayer: any = null;
  let ids = useRef<any>({
    fileId: '',
    resourceId: getSearchParams().liveId,
    lessonId: getSearchParams().id,
    courseId: getSearchParams().courseId,
    source: 0,
    userId: getUserId(),
  });

  const searchParams = useRef<N>(getSearchParams());
  const [listsInfo, setPlaybackLists] = useState<ListsInfo>({
    playBack: false,
    playBackLists: [],
    provider: -1,
  });
  const [selectedInfo, setSelectedInfo] = useState<SelectedInfo>({
    i: 0,
    url: '',
  });
  // const [fileType, setFileType] = useState<string>('');

  const playBackModal = useCallback(() => {
    const { ignoreClose } = searchParams.current;
    Modal.info({
      title: '将于当晚生成回看，请于明日进行查看！',
      onOk() {
        if (!ignoreClose) {
          (window as any).history.back();
        }
      },
    });
  }, []);

  const createLocalPlayBackUrl = useCallback(async (fileId: string, fileName: string) => {
    const { data, status } = await AxiosWrap({
      url: `/files/${fileId}/preview?type=${0}&fileName=${encodeURIComponent(fileName)}`,
    });
    if (status === 200 && data) {
      // setFileType(data.extension);
      return data.cdnUrl;
    }
    return '';
  }, []);

  const ceatePlayBackUrl = useCallback(
    (info: any): Promise<string> => {
      const { playUrl, url, token, name, fileId } = info;
      ids.current.fileId = fileId;
      return Promise.resolve(createLocalPlayBackUrl(fileId, name));
    },
    [createLocalPlayBackUrl],
  );

  const enterPlayBack = useCallback(
    async (info: any[], provider: number) => {
      if (!info || (info && info.length < 1)) {
        playBackModal();
        return;
      }
      setPlaybackLists({
        playBack: true,
        playBackLists: info,
        provider,
      });
      setSelectedInfo({
        i: 0,
        url: await ceatePlayBackUrl(info[0]),
      });
    },
    [playBackModal, ceatePlayBackUrl],
  );

  // 创建回看
  const cratePlayBack = useCallback(
    (playBack: PlaybackInfo) => {
      const { provider, easteduPlaybacks } = playBack;
      enterPlayBack(easteduPlaybacks, provider);
    },
    [enterPlayBack],
  );

  const onPlayBackChange = useCallback(
    async (review: any, i: number) => {
      if (i !== selectedInfo.i) {
        setSelectedInfo({
          i,
          url: await ceatePlayBackUrl(review),
        });
      }
    },
    [selectedInfo, ceatePlayBackUrl],
  );

  // const handleMedia = useCallback((media: any) => {
  //   media.on('play', () => {
  //     recordPlayingTime.startPlayTime();
  //   });
  //   media.on('pause', () => {
  //     isPaused.current = 1;
  //     recordPlayingTime.stopPlayTime();
  //   });
  //   media.on('timeupdate', () => {
  //     recordPlayingTime.getStartAndEnd(media.currentTime(), media.duration());
  //   });

  //   // 播放速率更改
  //   media.on('ratechange', () => {
  //     recordPlayingTime.updateSpeed(media.playbackRate());
  //   });
  // }, []);

  useEffect(() => {
    const { provider } = playbackInfo;
    if (provider !== -1) {
      cratePlayBack(playbackInfo);
    }
  }, [playbackInfo, cratePlayBack]);

  // useEffect(() => {
  //   const f = async () => {
  //     const {
  //       data: { unixtime },
  //     } = await AxiosWrap({ baseURL: apiConfig.ip });
  //     Object.assign(playingTimeParams.current, { sessionId: unixtime * 1000 });
  //   };

  //   f();
  // }, []);

  useEffect(() => {
    return () => {
      recordPlayingTime.clearStatus();
    };
  }, []);

  const onSiderTrack = (data: any) => {
    switch (data.trackType) {
      case 'PROGRESS_CLICK':
      case 'DRAG_END':
      case 'MARKER_CLICK':
        if (xgPlayer?.currentTime < xgPlayer?.duration) {
          isTurnTo.current = true;
        }
        break;
      default:
        break;
    }
  };

  const playDom = () => {
    if (!selectedInfo.url) {
      return null;
    }
    // 点播课时且是mp4
    return (
      <VideoMarkerPlayer
        defaultSilderOpen
        theme="#2683f5"
        videoUrl={selectedInfo.url}
        onVideoTrack={(data) => onSiderTrack(data)}
        playerOptions={
          {
            events: {
              play: (player: any) => {
                xgPlayer = player;
                PlayTimeFn.startPlayTime({ ...ids.current });
              },
              pause: (player: any) => {
                PlayTimeFn.stopPlayTime();
              },
              ended: (player: any) => {
                player.exitFullscreen();
              },
              timeupdate: (player: any) => {
                PlayTimeFn.getStartAndEnd(player.currentTime, player.duration, isTurnTo.current);
                isTurnTo.current = false;
              },
              ratechange: (player: any) => {
                PlayTimeFn.changePlayRate(player.playbackRate);
              },
            },
            xgplayerOptions: {
              autoplayMuted: false,
              autoplay: true,
            },
          } as any
        }
      />
    );
  };

  return (
    <>
      {listsInfo.playBack && (
        <div className="play-back">
          {playDom()}
          {/* {listsInfo.provider !== 2 ? (
            <iframe title="iframe" frameBorder="0" src={selectedInfo.url} />
          ) : (
            <div className="media-container">
              {selectedInfo.url && (
                <ResourceViewCom
                  autoPlay={false}
                  mediaType={fileType}
                  mediaAddress={selectedInfo.url}
                  playerCallBack={handleMedia}
                />
              )}
            </div>
          )} */}
          {listsInfo.playBackLists.length > 1 && (
            <div className="review-bar">
              {listsInfo.playBackLists.map((review: any, i: number) => (
                <div
                  className={`review-item ${selectedInfo.i === i && 'item-selected'}`}
                  onClick={() => onPlayBackChange(review, i)}
                  key={i}
                >
                  {selectedInfo.i === i && <img src={livingGif} alt="" />}
                  {review.name || review.subject}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default memo(LivePlayBack);
